import { captureException } from "@sentry/react";
import { apiClient } from ".";
import { useQuery } from "@tanstack/react-query";

export const getLoginStatus = async ({ id }: { id: string }) => {
  const response = await apiClient({
    url: `/auth/auth`,
    method: "GET",
    params: {
      id,
    },
  });
  return response.data;
};

export const useGetLoginStatus = ({
  id,
  enabled,
}: {
  id: string;
  enabled: boolean;
}) => {
  const loginStatusQuery = useQuery({
    queryKey: ["get-login-status", id],
    queryFn: () => getLoginStatus({ id }),
    retry: 3,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 5000),
    refetchInterval: (query) => {
      const status = query.state.data?.body?.status;
      if (status === "complete" || status === "failed") {
        return false;
      }
      return 500;
    },
    refetchIntervalInBackground: true,
    refetchOnWindowFocus: false,
    enabled,
    staleTime: Infinity,
    throwOnError: (error) => {
      captureException(error, {
        tags: {
          operation: "get-login-status",
          errorType: error.name || "UnknownError",
        },
        extra: {
          apiEndpoint: `/auth/auth?id=${id}`,
          transactionId: id,
          errorMessage: error.message,
        },
        level: "error",
      });
      return false;
    },
  });
  return loginStatusQuery;
};
